//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from "vuex";
import { date } from "quasar";
//import wrapCsvValue from "../../mixins/wrapCsvValue";
export default {
  data() {
    return {
      pagination: {
        rowsPerPage: 30, // current rows per page being displayed
        sortBy: "ProductNumber",
        descending: false,
      },
      columns: [
        {
          name: "ProductNumber",
          align: "left",
          label: this.$t("stock.productNo"),
          field: "productNumber",
          style: "width: 300px",
          sortable: true,
        },
        {
          name: "ProductName",
          align: "left",
          label: this.$t("stock.productName"),
          field: "productName",
          sortable: true,
        },

        {
          name: "Warehouse",
          align: "left",
          label: this.$t("stock.warehouse"),
          field: "warehouseName",
          style: "width:210px",
          sortable: true,
        },
        {
          name: "Location",
          align: "left",
          label: this.$t("stock.location"),
          field: "locationName",
          style: "width:210px",
          sortable: true,
        },
        {
          name: "lastCountDate",
          align: "left",
          label: "Sist telt",
          field: "lastCountDate",
          style: "width:210px",
          format: (val) => date.formatDate(val, "DD-MM-YYYY"),
          sortable: true,
        },
        {
          name: "Quantity",
          align: "right",
          label: this.$t("stock.quantity"),
          style: "width:90px",
          field: "quantity",
          sortable: true,
        },
      ],
      filter: "",
      stocks: [],
      showAction: false,
      selectedStock: {},
      showNewStock: false,
      showMove: false,
      showChange: false,
      adjustedQuantity: 0,
      quantity: 0,
      changeComment: "",
      newWarehouseId: -1,
      newLocationId: -1,
      newProdctId: -1,
      Warehouses: [],
      FilterWarehouses: [],
      Locations: [],
      FilterLocations: [],
      Products: [],
      FilterProducts: [],
    };
  },
  async mounted() {
    await this.refresh();
    this.Warehouses = this.warehouses;
    this.FilterWarehouses = this.warehouses;
    this.Locations = this.locations;
    this.FilterLocations = this.locations;
    this.Products = await this.getArticles();
    this.FilterProducts = this.Products;
  },
  computed: {
    ...mapState("main", ["warehouses", "locations"]),

    newQuantityForLocation: function() {
      return (
        parseInt(this.selectedStock.quantity) + parseInt(this.adjustedQuantity)
      );
    },
  },

  watch: {
    newWarehouseId(newValue, oldValue) {
      if (newValue != oldValue) {
        this.newLocationId = -1;
      }
    },
  },

  methods: {
    ...mapActions("main", [
      "getStocks",
      "postStock",
      "moveStock",
      "getArticles",
    ]),

    onRowClick(evt, row) {
      this.resetForm();
      this.selectedStock = row;
      this.newWarehouseId = row.warehouseId;
      this.showAction = true;
    },

    resetForm() {
      this.showMove = false;
      this.showChange = false;
      this.showNewStock = false;
      this.adjustedQuantity = 0;
      this.quantity = 0;
      this.changeComment = "";
      this.newLocationId = -1;
      this.newProdctId = -1;
      this.selectedStock = {};
    },

    newStock() {
      this.resetForm();
      this.showNewStock = true;
      this.showAction = true;
    },

    async refresh() {
      this.stocks = [];
      const notif = this.$q.notify({
        type: "ongoing",
        message: "Laster data...",
      });

      this.stocks = await this.getStocks();

      setTimeout(() => {
        notif();
      }, 500);
    },

    async saveStockItem() {
      if (this.showChange) {
        var postStock = {};
        postStock.productId = this.selectedStock.productId;
        postStock.locationId = this.selectedStock.locationId;
        postStock.quantityChange = parseFloat(this.adjustedQuantity);
        postStock.comment = this.changeComment;

        try {
          var createdDto = await this.postStock(postStock);
          if (createdDto && createdDto.id > 0) {
            await this.refresh();
            this.showAction = false;

            this.$q.notify({
              type: "positive",
              message: this.$t("stock.changeCompleted"),
            });
          } else {
            this.$q.notify({
              type: "negative",
              message: this.$t("common.errorSave"),
            });
          }
        } catch (err) {
          this.showAction = false;

          console.log(err.message);
          this.$q.notify({
            type: "negative",
            message: this.$t("common.errorSave"),
          });
        }
      } else if (this.showMove) {
        var moveStock = {};
        moveStock.productId = this.selectedStock.productId;
        moveStock.fromLocationId = this.selectedStock.locationId;
        moveStock.toLocationId = this.newLocationId;
        moveStock.quantity = parseFloat(this.quantity);
        moveStock.comment = this.changeComment;

        try {
          var success = await this.moveStock(moveStock);

          if (success) {
            await this.refresh();
            this.showAction = false;
            this.$q.notify({
              type: "positive",
              message: this.$t("stock.moveCompleted"),
            });
          } else {
            this.showAction = false;
            this.$q.notify({
              type: "negative",
              message: this.$t("common.errorSave"),
            });
          }
        } catch (err) {
          this.showAction = false;

          console.log(err.message);
          this.$q.notify({
            type: "negative",
            message: this.$t("common.errorSave"),
          });
        }
      } else if (this.showNewStock) {
        var newStock = {};
        newStock.productId = this.newProdctId;
        newStock.locationId = this.newLocationId;
        newStock.quantityChange = parseFloat(this.quantity);
        newStock.comment = "";

        try {
          var newStockDto = await this.postStock(newStock);
          if (newStockDto && newStockDto.id > 0) {
            await this.refresh();
            this.showAction = false;

            this.$q.notify({
              type: "positive",
              message: this.$t("stock.createComplete"),
            });
          } else {
            this.$q.notify({
              type: "negative",
              message: this.$t("common.errorSave"),
            });
          }
        } catch (err) {
          this.showAction = false;

          console.log(err.message);
          this.$q.notify({
            type: "negative",
            message: this.$t("common.errorSave"),
          });
        }
      }
    },

    getProductsFilter(val, update) {
      console.log("getProductsFilter", val);
      if (!this.Products) {
        update();
        return;
      }
      update(() => {
        this.Products = this.FilterProducts.filter(
          (p) => p.productName.toLowerCase().indexOf(val.toLowerCase()) > -1
        );

        console.log("getProductsFilter update", this.Products);
      });
    },

    getWarehouseFilter(val, update) {
      console.log("getWarehouseFilter", this.Warehouses);
      if (!this.Warehouses) {
        update();
        return;
      }
      update(() => {
        this.Warehouses = this.FilterWarehouses.filter(
          (w) =>
            !w.isDeleted &&
            w.warehouseName.toLowerCase().indexOf(val.toLowerCase()) > -1
        );

        console.log("getWarehouseFilter update", this.Locations);
      });
    },

    getLocationsFilter(val, update) {
      console.log("getLocationsFilter", this.Locations);
      if (!this.Locations) {
        update();
        return;
      }
      update(() => {
        this.Locations = this.FilterLocations.filter(
          (l) =>
            (this.newWarehouseId < 1 || l.warehouseId == this.newWarehouseId) &&
            !l.isDeleted &&
            l.locationName.toLowerCase().indexOf(val.toLowerCase()) > -1
        );

        console.log("getLocationsFilter update", this.Locations);
      });
    },

    exportTable() {
      console.log("export");
    },
  },
};
